export default "__VITE_ASSET__Cbl2VyCY__"